// extracted by mini-css-extract-plugin
module.exports = {"attrComponent":"index-module--attr-component--3FLXA"};